import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import '../styles/complete_video.scss';

import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';

import '../styles/transition-inner-chapter.scss';
import '../styles/transition-group.scss';
import '../styles/mobile_chapter_one.scss';

import Iconset from './icons';
import Audioelement from './audioelement';
import M_Timeline from './mobile_timeline';


import VideoTrigger from './videoTrigger';
import Shareelement from './shareelement';
import Warenkorb from './warenkorb_menu';

import NoteIntro from './noteintro';

import LoadingScreen from './loading_screen';
import Outro from './outro-screen';

import Pause_menu from './pause_menu';

import WifiView from './wifi';

if(_assets.isMobile){
  setTimeout(function(){
      // This hides the address bar:
      window.scrollTo(0, 1);
  }, 0);
}

class Mobile_Chapter_one extends React.Component{

	constructor(props){
		super(props);

		this.state={
			isPlaying : false,
			activeVideo : 1,
			frameX : 2560,
			frameY : 1440,
			timeInPercentage : 0,
			canplaythrough : false,
			showNote : true,
			hasPlayedFirst : false,
			canTrigger : false,

			//only for iOS
			showVideoTrigger : false,

			timecode : 0,
			frameAspect : 2560 / 1440,
			windowX : window.innerWidth,
			windowY : window.innerHeight,
			currentChapter : 0,
			audioIsActive : false,
			maxVideo : 1, // switch video on tab
			videoSource : _assets.loaded.completeVideo,
			videoLoadStatus : 0,
			source : null,
		}

		this.play = this.play.bind(this);
		this.pause = this.pause.bind(this);
		this.addHandler();
	}

	componentDidMount(){
		console.log('mobile chapter did mount');
	
		this.refs.video.setAttribute('webkit-playsinline',true);
		if(this.props.firstSession){
			this.setFrameProp();
			this.prepareVideo(_assets.loaded.mobile_part_first_Video,function(){

				if(localStorage.getItem('coming-from-intro') === "true"){
					this.refs.video.play();
					this.setState({
						isPlaying : true,
					});
				}

				console.log('autoplay');
			}.bind(this));
		}
	}

	setFrameProp(){
		let aspect = this.state.windowX / this.state.windowY;
		if(aspect < this.state.frameAspect){
			this.setState({
				frameX : Math.floor( this.state.windowY * this.state.frameAspect),
				frameY : Math.floor(this.state.windowY)
			});
		}else{
			this.setState({
				frameX : Math.floor( this.state.windowX),
				frameY : Math.floor(this.state.windowX / this.state.frameAspect)
			});
		}
	}

	setFrameSize(){
		this.setState({
			windowX : window.innerWidth,
			windowY : window.innerHeight
		});
		this.setFrameProp();
	}

	touchHandler(){
		let nextVideo = this.state.activeVideo;
			nextVideo = nextVideo >= this.state.maxVideo ? 0 : (nextVideo+=1);
		
		this.setState({
			activeVideo : nextVideo,
			showNote : false,
		});
	}


	addHandler(){

		window.addEventListener('resize', function(){
			this.setFrameSize();
		}.bind(this));

		window.addEventListener('keydown',function(event){
			if(event.keyCode == 32 && this.state.canTrigger){
				this.touchHandler();
			}
		}.bind(this));

		window.addEventListener('touchstart',function(event){
			if(this.state.isPlaying && this.state.canTrigger){
			  if(event.target.type != "range"){
					this.touchHandler();
				}
			}
		}.bind(this));
	}

	triggerPlay(){
		
		this.play();

		this.setState({
			showVideoTrigger : false
		});

		setTimeout(function(){
			console.log('meeeh, keep video and audio in sync hack');
			
			this.setState({
				isPlaying : false
			},function(){
				this.refs.video.pause();
				this.play();
			});
		}.bind(this),1650);
	}


	play(){

		//set video source onloadStart if not set already
		if(!this.source.hasAttribute('src')){
			console.log('must set source');
			this.setFrameProp();
			this.prepareVideo(_assets.loaded.mobile_part_first_Video,function(){
				var playPromise = this.refs.video.play();

				if(playPromise != "undefined"){
					playPromise.then(function(){
						//console.log('play promise success');
						this.setState({
							isPlaying : true
						});
					}.bind(this));
				}else{
					this.setState({
						isPlaying : true
					});
				}			
			}.bind(this));
			

		}else{
			
			var playPromise = this.refs.video.play();

			//console.log(playPromise);
			if(typeof playPromise != "undefined"){
				playPromise.then(function(){
					console.log('play promise success');
					this.setState({
						isPlaying : true
					});
				}.bind(this));
				
			}else{
				this.setState({
					isPlaying : true
				});
			}			
		}
	}

	pause(){
		this.refs.video.pause();
		this.setState({
			isPlaying : false
		})
	}

	getCurrentTime(event){
		if(this.state.currentChapter != 3 && this.state.currentChapter != 4){
			this.timeupdate(this.refs.video.currentTime, this.refs.video.duration);
		}
	}

	prepareVideo(src,cb){
		let srcBlob = (window.webkitURL ? webkitURL : URL).createObjectURL(src);
		this.setState({
			src : srcBlob
		},function(){
			this.source.setAttribute('src', this.state.src);
			this.refs.video.setAttribute('src', this.state.src);
			this.refs.video.addEventListener('timeupdate',this.getCurrentTime.bind(this,event));
			this.refs.video.addEventListener('ended',(event) => this.endeChapter(event));
			
			if(typeof cb != "undefined"){
				cb();
			}
		});		
	}

	endeChapter(){

		if(this.state.currentChapter == 1){
			this.setState({
				timecode : 0,
				timeInPercentage : 0,
				hasPlayedFirst : true
			})
			if(this.props.secondSession){
				this.chapterSelector(2);
			}else{
				this.chapterSelector(4);
			}
		}else{
			this.chapterSelector(3);
		}
	}

	timeupdate(timecode,duration){
		this.setState({
			timecode: timecode,
			timeInPercentage : timecode * 100 / duration
		});

		if(this.state.currentChapter != 2){

			if(this.state.timecode > 9){
				this.setState({
					canTrigger : true
				});
			}
			
			if(timecode > 0 && timecode < 31.9){
				this.setState({
					currentChapter : 0,
					audioIsActive : false,
					maxVideo : 1
				});
			}
			if(timecode > 31.9){
				this.setState({
					currentChapter : 1,
					activeVideo : 0,//reset to first video
					audioIsActive : false,
					maxVideo : 0
				});
			}
		}else{
			//ende
			if( timecode > 293){
				this.chapterSelector(3);
			}
		}
	}

	componentWillReceiveProps(nextProps){
		if(nextProps.firstSession && nextProps.secondSession){
			console.log('complete ready');
		}
	}

	componentWillUnmount(){
		console.log('detatch video listener');
	}

	chapterSelector(num){

		//go to loading screen
		if(num == 2 && !this.props.secondSession){
			num = 4;
		}

		console.log('chapterSelector' , num);

		if(this.state.currentChapter == 2){
			this.pause();
			
			//skip to next chapter only if src is set properly
			this.prepareVideo(_assets.loaded.mobile_part_first_Video,function(){

				this.setState({
					audioIsActive : false,
					makeAudioActive : false,
					timecode : 0,
					isPlaying : false,
					activeVideo : 1,
					timeInPercentage : 0,
					currentChapter : num
				});

				var chapterTime = 0;

				if(num == 1){
					chapterTime = 31.9;
				}

				this.refs.video.currentTime = chapterTime;
			}.bind(this));
			return false;
		}

		var chapterTime = 0;
		switch(parseFloat(num)){
			case 0:
				chapterTime = 0;
				this.setState({
					makeAudioActive : false,
					src : _assets.loaded.mobile_part_first_Video
				});
			break;
			case 1:
				chapterTime = 31.9;
				this.setState({
					makeAudioActive : false,
					src : _assets.loaded.mobile_part_first_Video
				});
			break;
			case 2:
				
				chapterTime = 0;
				
				this.setState({
					currentChapter : 2,
					makeAudioActive : true,
					isPlaying : false,
					audioIsActive : true,
					timecode : 0,
					timeInPercentage : 0,
					maxVideo : 2,
					showVideoTrigger : true

				},function(){

					this.prepareVideo(_assets.loaded.mobile_part_last_Video);

				});
			break;
			case 3:
				
				console.log('ende');
				this.pause();
				this.setState({
					isPlaying: false,
					makeAudioActive : false,
					currentChapter : 3,
				});

				browserHistory.push('outro');

			break;

			//Loading Screen
			case 4:
				this.pause();
				this.setState({
					isPlaying : false,
					makeAudioActive : false,
					currentChapter : 4,
					audioIsActive : false
				});
			break;

			//default home screen
			default:
				chapterTime = 0;
			break;
		}
		if(this.state.currentChapter != 3 && this.state.currentChapter != 4){
			this.refs.video.currentTime = chapterTime;
		}
	}

	skipToChapter(event){

		let nextChapter = event.target.dataset.name;
		// skip to chapter in case secondSession but
		// is not loaded yet
		if(nextChapter == 2){
			this.setState({
				hasPlayedFirst : true
			});
		}
		this.chapterSelector(nextChapter);

	}

	goToLiveSessionAfterLoad(){
		//go to first chapter if not played already and coming from loading Screen
		if(!this.state.hasPlayedFirst && 
			this.props.firstSession && 
			!this.props.secondSession){
				this.chapterSelector(0);
		}
		if(this.props.firstSession && this.props.secondSession){
			this.chapterSelector(2);
		}
	}

render(){
		let videoStyle = {
			width : this.state.frameX +'px',
			height : this.state.frameY+'px'
		}

	return (<div className="mobile-frame">
	{(this.state.currentChapter == 3) &&
		<Outro />
	}
	{(this.state.currentChapter == 4) &&
		<LoadingScreen
			loadStatus={this.props.loadStatus}
			hasPlayedFirst = {this.state.hasPlayedFirst}
			firstSession={this.props.firstSession}
			secondSession={this.props.secondSession}
			goToInnerChapterAfterLoad={()=>this.goToLiveSessionAfterLoad()}
			wifiWasVisible = {this.props.wifiWasVisible}
			wifiAction = {this.props.wifiAction} />
	}
	{(this.state.currentChapter != 3 && this.state.currentChapter != 4) &&
		<div className="mobile-frame-inner">
		{/*Pausemenu*/}
				<ReactCSSTransitionGroup
					component= "div"
					className={"pause-menu-overlay-holder isPlaying-" + this.state.isPlaying + " active-chapter-" + this.state.innerChapter}
				  transitionName="fadeDown"
				  transitionAppear={true}
	     		transitionAppearTimeout={500}
				  transitionEnterTimeout={500}
				  transitionLeaveTimeout={300}>
						{	!this.state.isPlaying && !this.state.showVideoTrigger && 
							<Pause_menu 
								play = {this.play}
								chapter={1}/>
						}{ this.state.showVideoTrigger &&
							<VideoTrigger play = {()=>this.triggerPlay()} />
						}
					</ReactCSSTransitionGroup>

		{/*Intro*/}
		<ReactCSSTransitionGroup
			component= "div"
				className="absolute inner-note-intro"
		    transitionName="fade"
		    transitionEnterTimeout={500}
		    transitionLeaveTimeout={300}>
		    {(this.state.timecode > 0 && this.state.timecode < 6 && this.state.currentChapter != 2) &&
		    	<NoteIntro headline="Doing Good" />
		    }
		</ReactCSSTransitionGroup>

		{/*Tab Message*/}
		<ReactCSSTransitionGroup
			component= "div"
			className="main-tooltip-holder"
			transitionName="fade"
			transitionEnterTimeout={500}
			transitionLeaveTimeout={300}>
			{ (this.state.timecode > 9 && this.state.timecode < 30 && this.state.currentChapter != 2)  && 
			 	<div className="main-tooltip">
			 		<Iconset.loader />
			 		<span>tap the screen and see what will happen</span>
			 	</div>
			}

			{ (this.state.timecode > 4 && this.state.timecode < 280 && this.state.currentChapter == 2)  && 
			 	<div className="main-tooltip">
			 		<Iconset.loader />
			 		<span>tap the screen and see what will happen</span>
			 	</div>
			}
		</ReactCSSTransitionGroup>

		{/*press space*/}
		<ReactCSSTransitionGroup
			component= "div"
				className="absolute inner-note-space"
		    transitionName="fade"
		    transitionAppear={true}
    		transitionAppearTimeout={500}
		    transitionEnterTimeout={500}
		    transitionLeaveTimeout={300}>
		    {(this.state.timecode > 9 && this.state.showNote && this.state.timecode < 30 && this.state.currentChapter != 2 ) &&
		    	<div className="space-note" >
		    		<h1>tap to interact</h1>
		    	</div>
		    }
		</ReactCSSTransitionGroup>

		{/*VideoFrame*/}
					<div className={"video-frame active-video-frame-" + this.state.activeVideo}>
						{this.state.currentChapter == 2 &&
							<Audioelement 
								isPlaying = {this.state.isPlaying}
								makeAudioActive={this.state.audioIsActive}
								timecode = { this.state.timecode } />
						}
						<div className="video-frame-container" style={videoStyle}>
								<video autoplay preload="auto" className="video-complete" poster="" playsInline="true" ref="video">
									<source ref={(source) => {this.source = source}} type="video/mp4" />
								</video>
						</div>
					</div>

		{/*timeline*/}
					<ReactCSSTransitionGroup
						component= "div"
							className="absolute inner-intro-video mobile"
				      transitionName="fade"
				      transitionAppear={true}
	     				transitionAppearTimeout={500}
				      transitionEnterTimeout={500}
				      transitionLeaveTimeout={300}>
				      <nav className="main-nav">
									<div className="main-nav-inner">
										{/*<Warenkorb />*/}
										<M_Timeline
											timecode={this.state.timeInPercentage} 
											currentChapter ={this.state.currentChapter}
											skipToChapter={(event)=>this.skipToChapter(event)}
											play={this.play}
											pause={this.pause}
											isPlaying = {this.state.isPlaying}/>
										<Shareelement chapter={this.props.chapter} />
										{/*<ChapterNavi/>*/}
									</div>
							</nav>
							</ReactCSSTransitionGroup>
		</div>
	}
			</div>);
	}
}

export default Mobile_Chapter_one;


// WEBPACK FOOTER //
// ./src/scripts/mobile_chapter_one.js